import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import * as Icon from "react-feather";
import { SERVICE_COLORS, serviceLabel } from "./backofficeTracker";

/**
 * One client "header row" in the grouped tracker grid.
 *
 * Clicking anywhere on the row toggles expand/collapse.
 * The small open-in-new icon on the right is a real link to the client page
 * (its click is stopped from bubbling so it doesn't toggle the group).
 */
class ClientGroupHeader extends PureComponent {
	onToggle = () => {
		this.props.onToggle(this.props.group.client_id);
	};

	onClientLinkClick = e => {
		e.stopPropagation();
	};

	render() {
		const { group, expanded } = this.props;
		const count = group.engagements.length;
		const clientType = group.client_type || null;

		// Only render the link icon if we have what we need to navigate to the client page
		const clientHref = group.client_id && clientType ? `/clients/${clientType}/${group.client_id}` : null;

		return (
			<div
				className={"et-group-header " + (expanded ? "et-group-header--open" : "")}
				onClick={this.onToggle}
				role="button"
				tabIndex={0}
				onKeyDown={e => {
					if (e.key === "Enter" || e.key === " ") {
						e.preventDefault();
						this.onToggle();
					}
				}}
			>
				<div className="et-group-header__anchor">
					<span className="et-group-header__chevron">
						{expanded ? <Icon.ChevronDown size={14} /> : <Icon.ChevronRight size={14} />}
					</span>
					<span className="et-group-header__title">
						{group.client_name || "(No client)"}
					</span>
					<span className="et-group-header__count">
						{count} {count === 1 ? "engagement" : "engagements"}
					</span>
					{group.backoffice && (
						<span className="et-group-header__bo ft-et-bo-badge" title={"Backoffice: " + (group.backoffice.services || []).map(serviceLabel).join(", ")}>
							<span className="et-bo-dots">
								{(group.backoffice.services || []).map(s => (
									<i key={s} style={{ background: SERVICE_COLORS[s] || "#9aa0b0" }} />
								))}
							</span>
							+{group.backoffice.openCount} backoffice
						</span>
					)}
					{clientHref && (
						<Link
							to={clientHref}
							onClick={this.onClientLinkClick}
							className="et-group-header__open"
							title="Open client"
						>
							<Icon.ExternalLink size={11} />
						</Link>
					)}
				</div>

				<div className="et-group-header__rest" />
			</div>
		);
	}
}

export default ClientGroupHeader;
